  <div class="center-content table-container">
    <h5>Results</h5>
    @if (results.length === 0) {
      <div class="table">No results found.</div>
    }
    @else {
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Date</th>
          <th>Time</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (result of results; track result.key) {
          <tr>
            <td>{{ result.nameDesc }}</td>
            <td data-label="Date">{{ result.date }}</td>
            <td data-label="Time">{{ result.time }}</td>
            <td>
              <div class="button-cluster">
                <a class="button fancy-button inline" (click)="viewResult(result)" title="View">
                  <i class="material-icons">list</i>
                  <span>View</span>
                </a>
                <a class="button fancy-button inline" (click)="deleteResult(result)" title="Delete">
                  <i class="material-icons">delete</i>
                  <span>Delete</span>
                </a>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    }
</div>